// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2E6WF","form":"styles_form__1vQfl"};